import {SettingsActions, SettingsActionTypes} from "./SettingsActions";
import {AppContext, MaintenanceAndServerTime, Settings} from "../http/protocol";
import { BalanceUpdateFrequency, defaultBalanceUpdateFrequency } from "../ui/BalanceUpdater";
import { UserAction, UserActionTypes } from "../user/UserActions";

export enum WindowSize {
    WIDTH_XS = 575,
    WIDTH_SM = 576,
    WIDTH_MD = 768,
    WIDTH_LG = 992,
    WIDTH_XL = 1200
}

export interface SettingsState {
    settings?: Settings;
    isFetching: boolean;
    error?: string;
    windowSize: number;
    mobile? : boolean;
    maintenance? : MaintenanceAndServerTime;
    serverTimeOffset?: number;
    country?: string;
    jurisdictionId?: string;
    isBlocked?: boolean;
    balanceUpdateFrequency?: BalanceUpdateFrequency;
    appContext: AppContext|undefined;
}

const initialState: SettingsState = {
    settings: undefined,
    isFetching: false,
    error: undefined,
    windowSize: WindowSize.WIDTH_XL,
    mobile: false,
    isBlocked: false,
    balanceUpdateFrequency: defaultBalanceUpdateFrequency,
    appContext: undefined,
};

export function getTime(d? : number | Date) {
    if(!d) {
        return 0;
    }
    if(typeof(d) == "number") {
        return d;
    } else {
        return d.getTime();
    }
}

export function settingsReducer (state = initialState, action: SettingsActions|UserAction): SettingsState {
    switch (action.type) {
        case SettingsActionTypes.COUNTRY:
            return {...state, country : action.payload }
        case SettingsActionTypes.JURISDICTION:
            return {...state, jurisdictionId : action.payload }
        case SettingsActionTypes.MAINTENANCE_RESPONSE:
            return {...state, maintenance : action.payload, serverTimeOffset : Date.now() - getTime(action.payload.serverTime)}
        case SettingsActionTypes.UPDATE_CURRENCIES:
            return {...state, settings : {...state.settings, currencies : action.payload}}
        case SettingsActionTypes.FETCH_SETTINGS_REQUEST:
            return {...state, isFetching: true};
        case SettingsActionTypes.FETCH_SETTINGS_SUCCESS:
            return {...state, isFetching: false, settings: action.payload};
        case SettingsActionTypes.FETCH_SETTINGS_ERROR:
            return {...state, isFetching: false, error: action.payload};
        case SettingsActionTypes.SET_VIEW_SIZE_BR:
            return {...state, windowSize: action.payload.windowSize ,mobile : action.payload.mobile};
        case SettingsActionTypes.COUNTRY_IS_BLOCKED:
            return {...state, isBlocked:action.payload};
        case SettingsActionTypes.CHANGE_BALANCE_UPDATE_FREQUENCY:
            return {...state, balanceUpdateFrequency: action.payload};
        case SettingsActionTypes.SET_APP_CONTEXT:
            return {...state, appContext: action.payload};
        case UserActionTypes.USER_INFO_RESPONSE:
            if(action.info.attributes?.appContext === AppContext.MAYAMINIAPP) {
                return {...state, appContext: AppContext.MAYAMINIAPP};
            }
            if(action.info.attributes?.appContext === AppContext.GLIFE) {
                return {...state, appContext: AppContext.GLIFE};
            }
            return state;
        default:
            return state;
    }
}